import {Map} from "immutable";

// We may construct an id from a normal object as well.
export function itemComposedId(item = Map()) {
  let [kind, code] = Map.isMap(item) ? [item.get("kind"), item.get("code")] : [item.kind, item.code];
  return `${kind}:${code}`;
}

export function isItemComposedId(id) {
  return String(id).split(":").length === 2;
}

export function getComposedIdComponents(id) {
  return String(id).split(":");
}